import { Helper } from '@/mixin/helper'
import { Cookie } from '@/mixin/local-cookie'
import store from '@/state/store'

export default [
  {
    path: '/',
    name: 'Dashboard',
    apollo: {},
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, from, next) {
        if (
          localStorage.getItem('token') === null &&
          process.env.VUE_APP_INTEGRATE_IDENTITY !== 'true'
        ) {
          if (localStorage.getItem('domainName') !== null) {
            window.location.href = `${window.location.protocol}//${localStorage.getItem(
              'domainName'
            )}/login`
          } else {
            next({ name: 'Login' })
          }
        } else {
          Helper.methods.userLogging('Access', _)
          if (process.env.VUE_APP_INTEGRATE_IDENTITY !== 'true') {
            Helper.methods.getAccessRight('qcDevice')
              ? next({ name: 'QC Device' })
              : next({ name: 'Master Home Page' })
          } else {
            if (store.state.identity.whoami === null) {
              next({ name: 'Login' })
            } else {
              if (
                store.getters['identity/hasAccess']([
                  'sms-device-setting:read',
                  'sms-device-register:read',
                ])
              ) {
                next({ name: 'Master Home Page' })
              } else {
                next({ name: 'QC Device' })
              }
            }
          }
        }
      },
    },
    component: () => import(/* webpackChunkName: "dashboard" */ './views/qcdevice'),
  },

  {
    path: '/login/',
    name: 'Login',
    component: () => import(/* webpackChunkName: "auth" */ './views/account/login'),
    meta: {
      guestPage: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        // If the user is already logged in
        if (store.state.identity.whoami !== null) {
          // Redirect to the home page instead
          Helper.methods.userLogging('Login', _)
          window.location.href = '/'
        } else {
          if (localStorage.getItem('domainName') !== null) {
            // Prevent local development cannot go to login
            if (localStorage.getItem('domainName') == window.location.host) {
              return next()
            }
            window.location.href = `${window.location.protocol}//${localStorage.getItem(
              'domainName'
            )}/login`
          } else {
            next()
          }
        }
      },
    },
  },

  {
    path: '/authenticate/:auth',
    name: 'auth',
    mixins: [Helper],
    meta: {
      guestPage: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        // If the user is already logged in
        if (store.state.identity.whoami !== null) {
          // Redirect to the home page instead
          next({ name: 'Dashboard' })
        } else {
          // Check Auth Token
          if (_.params.auth !== null) {
            store.dispatch('identity/logout').then(() => {
              Cookie.setLocalCookie('resource', _.params.auth, 'Session')
              localStorage.setItem('domainName', window.location.host)
              Helper.methods.userLogging('Login', _)

              window.location.href = '/?isLoginSuccess=true'
            })
          } else {
            // Continue to the login page
            next({ name: 'Login' })
          }
        }
      },
    },
    // component: () => import('./views/account/login'),
  },

  {
    path: '/logout/',
    name: 'logout',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Logout', _)
        localStorage.removeItem('token')
        const cookies = Cookie.getLocalCookie()
        // if the token is set locally (HttpOnly = false) then the token will detected
        if (cookies.resource) {
          Cookie.setLocalCookie('resource', '', new Date().toString())
          return next({ name: 'Login' })
        }

        // if there is no token locally and the user logged in (this exactly from cookie)
        // then revoke token via api
        if (store.state.identity.whoami != null) {
          return store.dispatch('identity/logout').then(() => {
            next({ name: 'Login' })
          })
        }

        // default action for exisiting localStorage token
        next({ name: 'Login' })
      },
    },
  },

  {
    path: '/404/',
    name: '404',
    component: require(/* webpackChunkName: "other" */ './views/utility/404').default,
  },

  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '*',
    redirect: '404',
  },

  // Work Order Dashboard
  {
    path: '/dashboard/',
    name: 'Work Order Dashboard',
    meta: {
      authRequired: false,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () => import(/* webpackChunkName: "master" */ './views/workOrder/dashboard'),
  },

  // Work Order
  {
    path: '/work-order/',
    name: 'Work Order',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          localStorage.getItem('token') !== null &&
          process.env.VUE_APP_INTEGRATE_IDENTITY !== 'true'
        ) {
          next()
        } else {
          if (
            store.getters['identity/hasAccess']([
              'sms-wo-tracking:read',
              'sms-wo-validation:read',
              'sms-wo-timelog:read',
            ])
          ) {
            next()
          } else {
            next({ name: 'QC Device' })
          }
        }
      },
    },
    component: () => import(/* webpackChunkName: "master" */ './views/workOrder'),
  },

  // Work Order Validation
  {
    path: '/work-order/validation',
    name: 'Work Order Validation',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          localStorage.getItem('token') !== null &&
          process.env.VUE_APP_INTEGRATE_IDENTITY !== 'true'
        ) {
          next()
        } else {
          if (
            store.getters['identity/hasAccess']([
              'sms-wo-validation:create',
              'sms-wo-validation:read',
              'sms-wo-validation:update',
              'sms-wo-validation:delete',
            ])
          ) {
            next()
          } else {
            next({ name: 'Work Order' })
          }
        }
      },
    },
    component: () => import(/* webpackChunkName: "master" */ './views/workOrder/validation'),
  },

  {
    path: '/work-order/validation/form/:wo_number',
    name: 'Work Order Validation Form',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          localStorage.getItem('token') !== null &&
          process.env.VUE_APP_INTEGRATE_IDENTITY !== 'true'
        ) {
          next()
        } else {
          if (
            store.getters['identity/hasAccess']([
              'sms-wo-validation:create',
              'sms-wo-validation:read',
              'sms-wo-validation:update',
              'sms-wo-validation:delete',
            ])
          ) {
            next()
          } else {
            next({ name: 'Work Order' })
          }
        }
      },
    },
    component: () => import(/* webpackChunkName: "master" */ './views/workOrder/validation/form'),
  },

  // Work Order Validation TJ
  {
    path: '/work-order/validation-tj',
    name: 'Work Order Validation TJ',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          localStorage.getItem('token') !== null &&
          process.env.VUE_APP_INTEGRATE_IDENTITY !== 'true'
        ) {
          next()
        } else {
          if (
            store.getters['identity/hasAccess']([
              'sms-wo-validation:create',
              'sms-wo-validation:read',
              'sms-wo-validation:update',
              'sms-wo-validation:delete',
            ])
          ) {
            next()
          } else {
            next({ name: 'Work Order' })
          }
        }
      },
    },
    component: () => import(/* webpackChunkName: "master" */ './views/workOrder/validationTJ'),
  },

  {
    path: '/work-order/validation-tj/form/:wo_number',
    name: 'Work Order Validation TJ Form',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          localStorage.getItem('token') !== null &&
          process.env.VUE_APP_INTEGRATE_IDENTITY !== 'true'
        ) {
          next()
        } else {
          if (
            store.getters['identity/hasAccess']([
              'sms-wo-validation:create',
              'sms-wo-validation:read',
              'sms-wo-validation:update',
              'sms-wo-validation:delete',
            ])
          ) {
            next()
          } else {
            next({ name: 'Work Order' })
          }
        }
      },
    },
    component: () => import(/* webpackChunkName: "master" */ './views/workOrder/validationTJ/form'),
  },

  {
    path: '/work-order/work-time',
    name: 'Work Order Work Time',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          localStorage.getItem('token') !== null &&
          process.env.VUE_APP_INTEGRATE_IDENTITY !== 'true'
        ) {
          next()
        } else {
          if (
            store.getters['identity/hasAccess']([
              'sms-wo-timelog:create',
              'sms-wo-timelog:read',
              'sms-wo-timelog:update',
              'sms-wo-timelog:delete',
            ])
          ) {
            next()
          } else {
            next({ name: 'Work Order' })
          }
        }
      },
    },
    component: () => import(/* webpackChunkName: "master" */ './views/workOrder/workTime'),
  },

  {
    path: '/work-order/location',
    name: 'Work Order Technician Location',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          localStorage.getItem('token') !== null &&
          process.env.VUE_APP_INTEGRATE_IDENTITY !== 'true'
        ) {
          next()
        } else {
          if (
            store.getters['identity/hasAccess']([
              'sms-wo-tracking:create',
              'sms-wo-tracking:read',
              'sms-wo-tracking:update',
              'sms-wo-tracking:delete',
            ])
          ) {
            next()
          } else {
            next({ name: 'Work Order' })
          }
        }
      },
    },
    component: () => import(/* webpackChunkName: "master" */ './views/workOrder/location'),
  },

  {
    path: '/work-order/location/processing',
    name: 'Technician Location',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          localStorage.getItem('token') !== null &&
          process.env.VUE_APP_INTEGRATE_IDENTITY !== 'true'
        ) {
          next()
        } else {
          if (
            store.getters['identity/hasAccess']([
              'sms-wo-tracking:create',
              'sms-wo-tracking:read',
              'sms-wo-tracking:update',
              'sms-wo-tracking:delete',
            ])
          ) {
            next()
          } else {
            next({ name: 'Work Order' })
          }
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "master" */ './views/workOrder/location/ProcessingLocation'),
  },

  {
    path: '/work-order/location/technician-address',
    name: 'Technician Address',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          localStorage.getItem('token') !== null &&
          process.env.VUE_APP_INTEGRATE_IDENTITY !== 'true'
        ) {
          next()
        } else {
          if (
            store.getters['identity/hasAccess']([
              'sms-wo-tracking:create',
              'sms-wo-tracking:read',
              'sms-wo-tracking:update',
              'sms-wo-tracking:delete',
            ])
          ) {
            next()
          } else {
            next({ name: 'Work Order' })
          }
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "master" */ './views/workOrder/location/TechnicianAddress'),
  },

  {
    path: '/work-order/location/nearest-technician',
    name: 'Nearest Technician',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          localStorage.getItem('token') !== null &&
          process.env.VUE_APP_INTEGRATE_IDENTITY !== 'true'
        ) {
          next()
        } else {
          if (
            store.getters['identity/hasAccess']([
              'sms-wo-tracking:create',
              'sms-wo-tracking:read',
              'sms-wo-tracking:update',
              'sms-wo-tracking:delete',
            ])
          ) {
            next()
          } else {
            next({ name: 'Work Order' })
          }
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "master" */ './views/workOrder/location/NearestTechnician'),
  },

  {
    path: '/work-order/done',
    name: 'Work Order Done',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          localStorage.getItem('token') !== null &&
          process.env.VUE_APP_INTEGRATE_IDENTITY !== 'true'
        ) {
          next()
        } else {
          if (
            store.getters['identity/hasAccess']([
              'sms-wo-tracking:create',
              'sms-wo-tracking:read',
              'sms-wo-tracking:update',
              'sms-wo-tracking:delete',
            ])
          ) {
            next()
          } else {
            next({ name: 'Work Order' })
          }
        }
      },
    },
    component: () => import(/* webpackChunkName: "master" */ './views/workOrder/done'),
  },

  // Done TJ
  {
    path: '/work-order/done-tj',
    name: 'Work Order Done TJ',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          localStorage.getItem('token') !== null &&
          process.env.VUE_APP_INTEGRATE_IDENTITY !== 'true'
        ) {
          next()
        } else {
          if (
            store.getters['identity/hasAccess']([
              'sms-wo-tracking:create',
              'sms-wo-tracking:read',
              'sms-wo-tracking:update',
              'sms-wo-tracking:delete',
            ])
          ) {
            next()
          } else {
            next({ name: 'Work Order' })
          }
        }
      },
    },
    component: () => import(/* webpackChunkName: "master" */ './views/workOrder/doneTJ'),
  },

  {
    path: '/work-order/sop',
    name: 'Work Order SOP',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          localStorage.getItem('token') !== null &&
          process.env.VUE_APP_INTEGRATE_IDENTITY !== 'true'
        ) {
          next()
        } else {
          if (
            store.getters['identity/hasAccess']([
              'sms-sop:create',
              'sms-sop:read',
              'sms-sop:update',
              'sms-sop:delete',
            ])
          ) {
            next()
          } else {
            next({ name: 'Work Order' })
          }
        }
      },
    },
    component: () => import('./views/workOrder/sop'),
  },

  {
    path: '/work-order/ai-training',
    name: 'Ai Training',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          localStorage.getItem('token') !== null &&
          process.env.VUE_APP_INTEGRATE_IDENTITY !== 'true'
        ) {
          next()
        } else {
          if (
            store.getters['identity/hasAccess']([
              'sms-wo-tracking:create',
              'sms-wo-tracking:read',
              'sms-wo-tracking:update',
              'sms-wo-tracking:delete',
            ])
          ) {
            next()
          } else {
            next({ name: 'Work Order' })
          }
        }
      },
    },
    component: () => import(/* webpackChunkName: "master" */ './views/workOrder/AiTraining/index'),
  },

  {
    path: '/work-order/ai-training/validation',
    name: 'Ai Training Validation',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          localStorage.getItem('token') !== null &&
          process.env.VUE_APP_INTEGRATE_IDENTITY !== 'true'
        ) {
          next()
        } else {
          if (
            store.getters['identity/hasAccess']([
              'sms-wo-tracking:create',
              'sms-wo-tracking:read',
              'sms-wo-tracking:update',
              'sms-wo-tracking:delete',
            ])
          ) {
            next()
          } else {
            next({ name: 'Work Order' })
          }
        }
      },
    },
    component: () => import(/* webpackChunkName: "master" */ './views/workOrder/AiTraining/validation'),
  },

  {
    path: '/work-order/sop/detail/:id',
    name: 'Work Order SOP Detail',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          localStorage.getItem('token') !== null &&
          process.env.VUE_APP_INTEGRATE_IDENTITY !== 'true'
        ) {
          next()
        } else {
          if (
            store.getters['identity/hasAccess']([
              'sms-sop:create',
              'sms-sop:read',
              'sms-sop:update',
              'sms-sop:delete',
            ])
          ) {
            next()
          } else {
            next({ name: 'Work Order SOP' })
          }
        }
      },
    },
    component: () => import('./views/workOrder/sop/form'),
  },

  {
    path: '/work-order/stock-technician',
    name: 'Stock Technician',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          localStorage.getItem('token') !== null &&
          process.env.VUE_APP_INTEGRATE_IDENTITY !== 'true'
        ) {
          next()
        } else {
          if (store.getters['identity/hasAccess'](['sms-stock-technician:read'])) {
            next()
          } else {
            next({ name: 'Work Order' })
          }
        }
      },
    },
    component: () => import('./views/workOrder/StockTechnician'),
  },

  {
    path: '/work-order/invalid-reason',
    name: 'Invalid Reason',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          localStorage.getItem('token') !== null &&
          process.env.VUE_APP_INTEGRATE_IDENTITY !== 'true'
        ) {
          next()
        } else {
          if (
            store.getters['identity/hasAccess']([
              'sms-sop-validation:create',
              'sms-sop-validation:read',
              'sms-sop-validation:update',
              'sms-sop-validation:delete',
            ])
          ) {
            next()
          } else {
            next({ name: 'Work Order' })
          }
        }
      },
    },
    // Sesuaikan path import dengan lokasi sebenarnya jika berbeda
    component: () => import(/* webpackChunkName: "master" */ './views/workOrder/invalid-reason/index.vue'),
  },

  // Manage Domain Page
  {
    path: '/domain/setting',
    name: 'Manage Domain Setting',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          localStorage.getItem('token') !== null &&
          process.env.VUE_APP_INTEGRATE_IDENTITY !== 'true'
        ) {
          next()
        } else {
          if (store.getters['identity/hasAccess'](['sms-md-company:read'])) {
            next()
          } else {
            next({ name: 'QC Device' })
          }
        }
      },
    },
    component: () => import(/* webpackChunkName: "master" */ './views/domain/setting'),
  },

  // Manage Domain Page
  {
    path: '/domain',
    name: 'Manage Domain',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          localStorage.getItem('token') !== null &&
          process.env.VUE_APP_INTEGRATE_IDENTITY !== 'true'
        ) {
          next()
        } else {
          if (store.getters['identity/hasAccess'](['sms-md-company:read'])) {
            next()
          } else {
            next({ name: 'QC Device' })
          }
        }
      },
    },
    component: () => import(/* webpackChunkName: "master" */ './views/domain'),
  },

  // Master Home Page
  {
    path: '/master/',
    name: 'Master Home Page',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          localStorage.getItem('token') !== null &&
          process.env.VUE_APP_INTEGRATE_IDENTITY !== 'true'
        ) {
          next()
        } else {
          if (
            store.getters['identity/hasAccess']([
              'sms-md-user:read',
              'sms-md-device:read',
              'sms-md-vehicle:read',
            ])
          ) {
            next()
          } else {
            store.getters['identity/hasAccess'](['sms-md-company:read'])
              ? next({ name: 'Manage Domain' })
              : next({ name: '404' })
          }
        }
      },
    },
    component: () => import(/* webpackChunkName: "master" */ './views/master'),
  },

  // Master User
  {
    path: '/master/user',
    name: 'Master User',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          localStorage.getItem('token') !== null &&
          process.env.VUE_APP_INTEGRATE_IDENTITY !== 'true'
        ) {
          next()
        } else {
          if (
            store.getters['identity/hasAccess']([
              'sms-md-user:create',
              'sms-md-user:read',
              'sms-md-user:update',
              'sms-md-user:delete',
            ])
          ) {
            next()
          } else {
            next({ name: 'Master Home Page' })
          }
        }
      },
    },
    component: () => import(/* webpackChunkName: "master" */ './views/master/user'),
  },

  // Master Fleet
  {
    path: '/master/fleet/',
    name: 'Master Fleet',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          localStorage.getItem('token') !== null &&
          process.env.VUE_APP_INTEGRATE_IDENTITY !== 'true'
        ) {
          next()
        } else {
          if (
            store.getters['identity/hasAccess']([
              'sms-md-vehicle:create',
              'sms-md-vehicle:read',
              'sms-md-vehicle:update',
              'sms-md-vehicle:delete',
            ])
          ) {
            next()
          } else {
            next({ name: 'Master Home Page' })
          }
        }
      },
    },
    component: () => import(/* webpackChunkName: "master" */ './views/master/fleet'),
  },

  /* Master Fleet Type */
  {
    path: '/master/fleet-type',
    name: 'Master Fleet Type',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          localStorage.getItem('token') !== null &&
          process.env.VUE_APP_INTEGRATE_IDENTITY !== 'true'
        ) {
          next()
        } else {
          if (
            store.getters['identity/hasAccess']([
              'sms-md-vehicle:create',
              'sms-md-vehicle:read',
              'sms-md-vehicle:update',
              'sms-md-vehicle:delete',
            ])
          ) {
            next()
          } else {
            next({ name: 'Master Home Page' })
          }
        }
      },
    },
    component: () => import(/* webpackChunkName: "master" */ './views/master/fleetType'),
  },

  // Master Tracking
  {
    path: '/master/tracking/',
    name: 'Master Tracking',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          localStorage.getItem('token') !== null &&
          process.env.VUE_APP_INTEGRATE_IDENTITY !== 'true'
        ) {
          next()
        } else {
          if (
            store.getters['identity/hasAccess']([
              'sms-md-device:create',
              'sms-md-device:read',
              'sms-md-device:update',
              'sms-md-device:delete',
            ])
          ) {
            next()
          } else {
            next({ name: 'Master Home Page' })
          }
        }
      },
    },
    component: () => import(/* webpackChunkName: "master" */ './views/master/tracking'),
  },

  // Master Multi Imei
  {
    path: '/master/multi-imei/',
    name: 'Master Multi Imei',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          localStorage.getItem('token') !== null &&
          process.env.VUE_APP_INTEGRATE_IDENTITY !== 'true'
        ) {
          next()
        } else {
          if (
            store.getters['identity/hasAccess']([
              'sms-device-multi-imei:create',
              'sms-device-multi-imei:read',
              'sms-device-multi-imei:update',
              'sms-device-multi-imei:delete',
            ])
          ) {
            next()
          } else {
            next({ name: 'Master Home Page' })
          }
        }
      },
    },
    component: () => import(/* webpackChunkName: "master" */ './views/master/MultiImei'),
  },

  {
    path: '/master/multi-imei/import',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          localStorage.getItem('token') !== null &&
          process.env.VUE_APP_INTEGRATE_IDENTITY !== 'true'
        ) {
          next()
        } else {
          if (
            store.getters['identity/hasAccess']([
              'sms-device-multi-imei:create',
              'sms-device-multi-imei:read',
              'sms-device-multi-imei:update',
              'sms-device-multi-imei:delete',
            ])
          ) {
            next()
          } else {
            next({ name: 'Master Home Page' })
          }
        }
      },
    },
    component: () => import(/* webpackChunkName: "master" */ './views/master/MultiImei/import'),
    children: [
      {
        path: '',
        name: 'Multi IMEI Import',
        component: () => import('@/router/views/master/MultiImei/contents/Upload.vue'),
      },
      {
        path: ':file/detail',
        name: 'Multi IMEI Import Detail',
        component: () => import('@/router/views/master/MultiImei/contents/Process.vue'),
      },
      {
        path: ':file/result',
        name: 'Multi IMEI Import Result',
        component: () => import('@/router/views/master/MultiImei/contents/Result.vue'),
        meta: {
          beforeResolve(_, routeFrom, next) {
            if (routeFrom.params.file === null || Object.keys(routeFrom.params)?.length === 0) {
              next({ name: 'Multi IMEI Import' })
            } else {
              next()
            }
          },
        },
      },
    ],
  },

  // QC Device Page
  {
    path: '/qcdevice/',
    name: 'QC Device',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          localStorage.getItem('token') !== null &&
          process.env.VUE_APP_INTEGRATE_IDENTITY !== 'true'
        ) {
          next()
        } else {
          if (
            store.getters['identity/hasAccess']([
              'sms-device-setting:read',
              'sms-device-register:read',
            ])
          ) {
            next()
          } else {
            next({ name: 'Master Home Page' })
          }
        }
      },
    },
    component: () => import('./views/qcdevice'),
  },

  // QC Device Image Validation
  {
    path: '/qcdevice/image-validation',
    name: 'Image Validation',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          localStorage.getItem('token') !== null &&
          process.env.VUE_APP_INTEGRATE_IDENTITY !== 'true'
        ) {
          next()
        } else {
          if (
            store.getters['identity/hasAccess']([
              'sms-device-setting:read',
              'sms-device-register:read',
            ])
          ) {
            next()
          } else {
            next({ name: 'QC Device' })
          }
        }
      },
    },
    component: () => import(/* webpackChunkName: "master" */ './views/qcdevice/imageValidation'),
  },

  // QC Device Register
  {
    path: '/qcdevice/register',
    name: 'Register Device',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          localStorage.getItem('token') !== null &&
          process.env.VUE_APP_INTEGRATE_IDENTITY !== 'true'
        ) {
          next()
        } else {
          if (
            store.getters['identity/hasAccess']([
              'sms-device-register:create',
              'sms-device-register:read',
              'sms-device-register:update',
              'sms-device-register:delete',
            ])
          ) {
            next()
          } else {
            next({ name: 'QC Device' })
          }
        }
      },
    },
    component: () => import(/* webpackChunkName: "master" */ './views/qcdevice/incomming'),
  },

  {
    path: '/qcdevice/rfid',
    name: 'Register RFID',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          localStorage.getItem('token') !== null &&
          process.env.VUE_APP_INTEGRATE_IDENTITY !== 'true'
        ) {
          next()
        } else {
          if (
            store.getters['identity/hasAccess']([
              'rfid:create',
              'rfid:read',
              'rfid:update',
              'rfid:delete',
            ])
          ) {
            next()
          } else {
            next({ name: 'QC Device' })
          }
        }
      },
    },
    component: () => import(/* webpackChunkName: "master" */ './views/qcdevice/rfid'),
  },

  {
    path: '/qcdevice/ibeacon',
    name: 'Register Ibeacon',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          localStorage.getItem('token') !== null &&
          process.env.VUE_APP_INTEGRATE_IDENTITY !== 'true'
        ) {
          next()
        } else {
          if (
            store.getters['identity/hasAccess']([
              'ibeacon:create',
              'ibeacon:read',
              'ibeacon:update',
              'ibeacon:delete',
            ])
          ) {
            next()
          } else {
            next({ name: 'QC Device' })
          }
        }
      },
    },
    component: () => import(/* webpackChunkName: "master" */ './views/qcdevice/ibeacon'),
  },

  {
    path: '/qcdevice/register/import',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          localStorage.getItem('token') !== null &&
          process.env.VUE_APP_INTEGRATE_IDENTITY !== 'true'
        ) {
          next()
        } else {
          if (
            store.getters['identity/hasAccess']([
              'sms-device-register:create',
              'sms-device-register:read',
              'sms-device-register:update',
              'sms-device-register:delete',
            ])
          ) {
            next()
          } else {
            next({ name: 'QC Device' })
          }
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "master" */ './views/qcdevice/incomming/importDevice'),
    children: [
      {
        path: '',
        name: 'Device Import',
        component: () => import('@/router/views/qcdevice/incomming/contents/Upload.vue'),
      },
      {
        path: ':file/detail',
        name: 'Device Import Detail',
        component: () => import('@/router/views/qcdevice/incomming/contents/Process.vue'),
      },
      {
        path: ':file/result',
        name: 'Device Import Result',
        component: () => import('@/router/views/qcdevice/incomming/contents/Result.vue'),
        meta: {
          beforeResolve(_, routeFrom, next) {
            if (routeFrom.params.file === null || Object.keys(routeFrom.params)?.length === 0) {
              next({ name: 'Device Import' })
            } else {
              next()
            }
          },
        },
      },
    ],
  },

  {
    path: '/qcdevice/register/import-set-to-customer',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          localStorage.getItem('token') !== null &&
          process.env.VUE_APP_INTEGRATE_IDENTITY !== 'true'
        ) {
          next()
        } else {
          if (
            store.getters['identity/hasAccess']([
              'sms-device-register:create',
              'sms-device-register:read',
              'sms-device-register:update',
              'sms-device-register:delete',
            ])
          ) {
            next()
          } else {
            next({ name: 'QC Device' })
          }
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "master" */ './views/qcdevice/incomming/ImportSetToCustomer'),
    children: [
      {
        path: '',
        name: 'Device Import Set To Customer',
        component: () =>
          import('@/router/views/qcdevice/incomming/contents/UploadSetToCustomer.vue'),
      },
      {
        path: 'process/:jobId',
        name: 'Device Import Set To Customer Process',
        component: () =>
          import('@/router/views/qcdevice/incomming/contents/ProcessSetToCustomer.vue'),
      },
      {
        path: 'result/:jobId',
        name: 'Device Import Set To Customer Result',
        component: () =>
          import('@/router/views/qcdevice/incomming/contents/ResultSetToCustomer.vue'),
      },
    ],
  },

  {
    path: '/qcdevice/rfid/import',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          localStorage.getItem('token') !== null &&
          process.env.VUE_APP_INTEGRATE_IDENTITY !== 'true'
        ) {
          next()
        } else {
          if (
            store.getters['identity/hasAccess']([
              'rfid:create',
              'rfid:read',
              'rfid:update',
              'rfid:delete',
            ])
          ) {
            next()
          } else {
            next({ name: 'QC Device' })
          }
        }
      },
    },
    component: () => import(/* webpackChunkName: "master" */ './views/qcdevice/rfid/importRfid'),
    children: [
      {
        path: '',
        name: 'RFID Import',
        component: () => import('@/router/views/qcdevice/rfid/contents/Upload.vue'),
      },
      {
        path: ':file/detail',
        name: 'RFID Import Detail',
        component: () => import('@/router/views/qcdevice/rfid/contents/Process.vue'),
      },
      {
        path: ':file/result',
        name: 'RFID Import Result',
        component: () => import('@/router/views/qcdevice/rfid/contents/Result.vue'),
        meta: {
          beforeResolve(_, routeFrom, next) {
            if (routeFrom.params.file === null || Object.keys(routeFrom.params)?.length === 0) {
              next({ name: 'RFID Import' })
            } else {
              next()
            }
          },
        },
      },
    ],
  },

  {
    path: '/qcdevice/ibeacon/import',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          localStorage.getItem('token') !== null &&
          process.env.VUE_APP_INTEGRATE_IDENTITY !== 'true'
        ) {
          next()
        } else {
          if (
            store.getters['identity/hasAccess']([
              'ibeacon:create',
              'ibeacon:read',
              'ibeacon:update',
              'ibeacon:delete',
            ])
          ) {
            next()
          } else {
            next({ name: 'QC Device' })
          }
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "master" */ './views/qcdevice/ibeacon/importIbeacon'),
    children: [
      {
        path: '',
        name: 'Beacon Import',
        component: () => import('@/router/views/qcdevice/ibeacon/contents/Upload.vue'),
      },
      {
        path: ':file/detail',
        name: 'Beacon Import Detail',
        component: () => import('@/router/views/qcdevice/ibeacon/contents/Process.vue'),
      },
      {
        path: ':file/result',
        name: 'Beacon Import Result',
        component: () => import('@/router/views/qcdevice/ibeacon/contents/Result.vue'),
        meta: {
          beforeResolve(_, routeFrom, next) {
            if (routeFrom.params.file === null || Object.keys(routeFrom.params)?.length === 0) {
              next({ name: 'Beacon Import' })
            } else {
              next()
            }
          },
        },
      },
    ],
  },

  /* Bulk Command Settings */
  {
    path: '/qcdevice/custom-online-command',
    name: 'Bulk Online Command',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          localStorage.getItem('token') !== null &&
          process.env.VUE_APP_INTEGRATE_IDENTITY !== 'true'
        ) {
          next()
        } else {
          if (
            store.getters['identity/hasAccess']([
              'sms-device-setting:create',
              'sms-device-setting:read',
              'sms-device-setting:update',
              'sms-device-setting:delete',
            ])
          ) {
            next()
          } else {
            next({ name: 'QC Device' })
          }
        }
      },
    },
    component: () => import(/* webpackChunkName: "setting" */ './views/qcdevice/bulkOnlineCommand'),
  },

  {
    path: '/qcdevice/vss-configuration',
    name: 'Vss Configuration',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          localStorage.getItem('token') !== null &&
          process.env.VUE_APP_INTEGRATE_IDENTITY !== 'true'
        ) {
          next()
        } else {
          if (
            store.getters['identity/hasAccess']([
              'sms-vss-configuration:create',
              'sms-vss-configuration:read',
              'sms-vss-configuration:update',
              'sms-vss-configuration:delete',
            ])
          ) {
            next()
          } else {
            next({ name: 'QC Device' })
          }
        }
      },
    },
    component: () => import('./views/qcdevice/vssConfiguration/Index.vue'),
  },

  {
    path: '/qcdevice/device-camera',
    name: 'Camera Configuration',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          localStorage.getItem('token') !== null &&
          process.env.VUE_APP_INTEGRATE_IDENTITY !== 'true'
        ) {
          next()
        } else {
          if (
            store.getters['identity/hasAccess']([
              'sms-device-camera:create',
              'sms-device-camera:read',
              'sms-device-camera:update',
              'sms-device-camera:delete',
            ])
          ) {
            next()
          } else {
            next({ name: 'QC Device' })
          }
        }
      },
    },
    component: () => import('./views/qcdevice/deviceCamera/Index.vue'),
  },

  // Setting Device
  {
    path: '/setting/setdevice',
    name: 'Setting Device',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          localStorage.getItem('token') !== null &&
          process.env.VUE_APP_INTEGRATE_IDENTITY !== 'true'
        ) {
          next()
        } else {
          if (
            store.getters['identity/hasAccess']([
              'sms-device-setting:create',
              'sms-device-setting:read',
              'sms-device-setting:update',
              'sms-device-setting:delete',
            ])
          ) {
            next()
          } else {
            next({ name: 'QC Device' })
          }
        }
      },
    },
    component: () => import(/* webpackChunkName: "setting" */ './views/setting/setdevice'),
  },

  /* SMS Gateway */
  {
    path: '/sms-gateway/',
    name: 'SMS Gateway',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          localStorage.getItem('token') !== null &&
          process.env.VUE_APP_INTEGRATE_IDENTITY !== 'true'
        ) {
          next()
        } else {
          if (store.getters['identity/hasAccess'](['sms-websocket:create'])) {
            next()
          } else {
            next({ name: 'QC Device' })
          }
        }
      },
    },
    component: () => import(/* webpackChunkName: "setting" */ './views/qcdevice/smsGateway'),
  },

  /* Online Command Settings */
  {
    path: '/online-command-setting/',
    name: 'Online Command Setting',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          localStorage.getItem('token') !== null &&
          process.env.VUE_APP_INTEGRATE_IDENTITY !== 'true'
        ) {
          next()
        } else {
          if (
            store.getters['identity/hasAccess']([
              'online-command-settings:read',
              'online-command-settings:create',
              'online-command-settings:delete',
            ])
          ) {
            next()
          } else {
            next({ name: 'QC Device' })
          }
        }
      },
    },
    component: () => import(/* webpackChunkName: "setting" */ './views/onlinecommand'),
  },

  {
    path: '/guideline',
    beforeEnter() {
      window.open(
        'https://websmstechapp.notion.site/1fc331608b49809ebab9c9e046329cf9?v=1fc331608b498001ba52000c6b47ec67',
        '_blank'
      ) // open in new tab
    },
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccess'](['sms-guideline:read'])) {
          next()
        } else {
          next({ name: 'QC Device' })
        }
      },
    },
  },

  {
    path: '/trackvideo-2/',
    name: 'Track Video V2',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccess']([
            'sms-device-setting:create',
            'sms-device-setting:read',
            'sms-device-setting:update',
            'sms-device-setting:delete',
          ])
        ) {
          next()
        } else {
          next({ name: 'QC Device' })
        }
      },
    },
    component: () => import('./views/trackvideo-2/'),
  },

  {
    path: '/qcdevice/log-history',
    name: 'Log History',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          localStorage.getItem('token') !== null &&
          process.env.VUE_APP_INTEGRATE_IDENTITY !== 'true'
        ) {
          next()
        } else {
          if (store.getters['identity/hasAccess'](['log_activity:read'])) {
            next()
          } else {
            next({ name: 'QC Device' })
          }
        }
      },
    },
    component: () => import('./views/qcdevice/logHistory'),
  },

  {
    path: '/qcdevice/custom-interval',
    name: 'Custom Interval',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          localStorage.getItem('token') !== null &&
          process.env.VUE_APP_INTEGRATE_IDENTITY !== 'true'
        ) {
          next()
        } else {
          if (
            store.getters['identity/hasAccess']([
              'sms-device-setting:create',
              'sms-device-setting:read',
              'sms-device-setting:update',
              'sms-device-setting:delete',
            ])
          ) {
            next()
          } else {
            next({ name: 'QC Device' })
          }
        }
      },
    },
    component: () => import('./views/qcdevice/customInterval'),
  },

  {
    path: '/webview/trackvideo/:id',
    name: 'TrackVideo Webview',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          localStorage.getItem('token') !== null &&
          process.env.VUE_APP_INTEGRATE_IDENTITY !== 'true'
        ) {
          next()
        } else {
          if (store.getters['identity/hasAccess'](['sms-device-setting:read'])) {
            next()
          } else {
            next({ name: 'QC Device' })
          }
        }
      },
    },
    component: () => import('./views/trackvideo-2/WebviewVideo.vue'),
  },

  {
    path: '/webview/audiocall/:id',
    name: 'Audio Call Webview',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          localStorage.getItem('token') !== null &&
          process.env.VUE_APP_INTEGRATE_IDENTITY !== 'true'
        ) {
          next()
        } else {
          if (store.getters['identity/hasAccess'](['sms-device-setting:read'])) {
            next()
          } else {
            next({ name: 'QC Device' })
          }
        }
      },
    },
    component: () => import('./views/two-way-communication/WebviewAudio.vue'),
  },

  {
    path: '/notifications',
    name: 'All Notifications',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          localStorage.getItem('token') !== null &&
          process.env.VUE_APP_INTEGRATE_IDENTITY !== 'true'
        ) {
          next()
        } else {
          if (store.getters['identity/hasAccess'](['sms-notification:read'])) {
            next()
          } else {
            next({ name: 'QC Device' })
          }
        }
      },
    },
    component: () => import('./views/notifications'),
  },

  {
    path: '/notifications/settings',
    name: 'Notification Settings',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        if (
          localStorage.getItem('token') !== null &&
          process.env.VUE_APP_INTEGRATE_IDENTITY !== 'true'
        ) {
          next()
        } else {
          // Check permission if needed
          if (store.getters['identity/hasAccess'](['sms-notification:read'])) {
            next()
          } else {
            next({ name: 'QC Device' })
          }
        }
      },
    },
    component: () => import('./views/notifications/settings'),
  },

  {
    path: '/report-dashboard',
    name: 'Report & Dashboard',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          localStorage.getItem('token') !== null &&
          process.env.VUE_APP_INTEGRATE_IDENTITY !== 'true'
        ) {
          next()
        } else {
          if (
            store.getters['identity/hasAccess']([
              'device-status-log:create',
              'device-status-log:read',
              'device-status-log:update',
              'device-status-log:delete',
            ])
          ) {
            next()
          } else {
            next({ name: 'QC Device' })
          }
        }
      },
    },
    component: () => import(/* webpackChunkName: "master" */ './views/report-dashboard'),
  },

  {
    path: '/report-dashboard/device-status',
    name: 'Device Status',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          localStorage.getItem('token') !== null &&
          process.env.VUE_APP_INTEGRATE_IDENTITY !== 'true'
        ) {
          next()
        } else {
          if (
            store.getters['identity/hasAccess']([
              'device-status-log:create',
              'device-status-log:read',
              'device-status-log:update',
              'device-status-log:delete',
            ])
          ) {
            next()
          } else {
            next({ name: 'QC Device' })
          }
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "master" */ './views/report-dashboard/deviceStatus.vue'),
  },

  {
    path: '/report-dashboard/create',
    name: 'Create Device Status Log',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          localStorage.getItem('token') !== null &&
          process.env.VUE_APP_INTEGRATE_IDENTITY !== 'true'
        ) {
          next()
        } else {
          if (
            store.getters['identity/hasAccess']([
              'device-status-log:create',
              'device-status-log:read',
              'device-status-log:update',
              'device-status-log:delete',
            ])
          ) {
            next()
          } else {
            next({ name: 'QC Device' })
          }
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "master" */ './views/report-dashboard/addDeviceStatusLog.vue'),
  },

  {
    path: '/report-dashboard/log-per-device/:identifier/:type',
    name: 'Device Status and History Detail',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          localStorage.getItem('token') !== null &&
          process.env.VUE_APP_INTEGRATE_IDENTITY !== 'true'
        ) {
          next()
        } else {
          if (
            store.getters['identity/hasAccess']([
              'device-status-log:create',
              'device-status-log:read',
              'device-status-log:update',
            ])
          ) {
            next()
          } else {
            next({ name: 'QC Device' })
          }
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "master" */ './views/report-dashboard/logPerDevice.vue'),
  },

  // Error Description
  {
    path: '/qcdevice/error-description',
    name: 'Error Description',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          localStorage.getItem('token') !== null &&
          process.env.VUE_APP_INTEGRATE_IDENTITY !== 'true'
        ) {
          next()
        } else {
          if (
            store.getters['identity/hasAccess']([
              'sms-error-description:create',
              'sms-error-description:read',
              'sms-error-description:update',
              'sms-error-description:delete',
            ])
          ) {
            next()
          } else {
            next({ name: 'QC Device' })
          }
        }
      },
    },
    component: () => import(/* webpackChunkName: "master" */ './views/qcdevice/error-description'),
  },

  // Planner
  {
    path: '/planner',
    name: 'Planner Menu',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          localStorage.getItem('token') !== null &&
          process.env.VUE_APP_INTEGRATE_IDENTITY !== 'true'
        ) {
          next()
        } else {
          if (
            store.getters['identity/hasAccess']([
              'sms-planner-wo-board:read',
              'sms-planner-calendar-schedule:read',
              'sms-planner-technicians:read',
              'sms-planner-package:read',
            ])
          ) {
            next()
          } else {
            next({ name: 'QC Device' })
          }
        }
      },
    },
    component: () => import(/* webpackChunkName: "master" */ './views/planner'),
  },
  {
    path: '/planner/wo-board',
    name: 'Planner WO Board',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          localStorage.getItem('token') !== null &&
          process.env.VUE_APP_INTEGRATE_IDENTITY !== 'true'
        ) {
          next()
        } else {
          if (store.getters['identity/hasAccess'](['sms-planner-wo-board:read'])) {
            next()
          } else {
            next({ name: 'Planner Menu' })
          }
        }
      },
    },
    component: () => import(/* webpackChunkName: "master" */ './views/planner/woBoard'),
  },
  {
    path: '/planner/wo-board/:woNumber',
    name: 'Planner WO Board Detail',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          localStorage.getItem('token') !== null &&
          process.env.VUE_APP_INTEGRATE_IDENTITY !== 'true'
        ) {
          next()
        } else {
          if (store.getters['identity/hasAccess'](['sms-planner-wo-board:read'])) {
            next()
          } else {
            next({ name: 'Planner Menu' })
          }
        }
      },
    },
    component: () => import(/* webpackChunkName: "master" */ './views/planner/woBoard/detail'),
  },
  {
    path: '/planner/calendar-schedule',
    name: 'Planner Calendar Schedule',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          localStorage.getItem('token') !== null &&
          process.env.VUE_APP_INTEGRATE_IDENTITY !== 'true'
        ) {
          next()
        } else {
          if (store.getters['identity/hasAccess'](['sms-planner-calendar-schedule:read'])) {
            next()
          } else {
            next({ name: 'Planner Menu' })
          }
        }
      },
    },
    component: () => import(/* webpackChunkName: "master" */ './views/planner/calendarSchedule'),
  },
  {
    path: '/planner/technicians',
    name: 'Planner Technicians',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          localStorage.getItem('token') !== null &&
          process.env.VUE_APP_INTEGRATE_IDENTITY !== 'true'
        ) {
          next()
        } else {
          if (store.getters['identity/hasAccess'](['sms-planner-technicians:read'])) {
            next()
          } else {
            next({ name: 'Planner Menu' })
          }
        }
      },
    },
    component: () => import(/* webpackChunkName: "master" */ './views/planner/technicians'),
  },
  {
    path: '/planner/package',
    name: 'Planner Package',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          localStorage.getItem('token') !== null &&
          process.env.VUE_APP_INTEGRATE_IDENTITY !== 'true'
        ) {
          next()
        } else {
          if (store.getters['identity/hasAccess'](['sms-planner-package:read'])) {
            next()
          } else {
            next({ name: 'Planner Menu' })
          }
        }
      },
    },
    component: () => import(/* webpackChunkName: "master" */ './views/planner/package'),
  },
]
